// Small helpers shared by the admin console panels.

/** Readable message from an axios error (FastAPI detail string, auth error object or validation error). */
export function errorMessage(error, fallback = "Something went wrong. Please try again.") {
  const data = error && error.response && error.response.data;
  const detail = data && data.detail;
  if (typeof detail === "string" && detail !== "Please check your input data") return detail;
  if (detail && typeof detail === "object" && detail.message) return detail.message;
  if (data && Array.isArray(data.Errors) && data.Errors.length) {
    const first = data.Errors[0];
    const field = Array.isArray(first.loc) ? first.loc[first.loc.length - 1] : "";
    return field ? `${field}: ${first.msg}` : first.msg;
  }
  if (error && !error.response) return "Could not reach the server. Check your connection.";
  return fallback;
}

export function initials(name) {
  return String(name || "?")
    .replace(/^dr\.?\s+/i, "")
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map(part => part[0].toUpperCase())
    .join("") || "?";
}

export function formatDate(value) {
  if (!value) return "—";
  const date = new Date(value);
  if (isNaN(date)) return "—";
  return date.toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" });
}

export function formatDateTime(value) {
  if (!value) return "Never";
  // The API sends naive UTC timestamps.
  const date = new Date(/[zZ]|[+-]\d\d:?\d\d$/.test(value) ? value : `${value}Z`);
  if (isNaN(date)) return "—";
  return date.toLocaleString("en-IN", { day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
}

export const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const STATUS_LABELS = {
  active: "Active",
  pending: "Pending",
  inactive: "Inactive",
  rejected: "Rejected",
};
